import { render, staticRenderFns } from "./IndexAsideStatic.vue?vue&type=template&id=581b3308&scoped=true"
import script from "./IndexAsideStatic.vue?vue&type=script&lang=js"
export * from "./IndexAsideStatic.vue?vue&type=script&lang=js"
import style0 from "./IndexAsideStatic.vue?vue&type=style&index=0&id=581b3308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules_admin/6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b3308",
  null
  
)

export default component.exports